import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppConstant } from '../../../../../../Assests/AppConstant';
import { sagaActions } from '../../../../../../../sagas/sagaActions';
import CommonToggleSwitch from '../../../../../Common/CommonToggleSwitch/CommonToggleSwitch';
import { getAuthReducer } from '../../../../../../../redux/reducers/reducerSlices/AuthReducer';
import { getUserSelector } from '../../../../../../../redux/reducers/reducerSlices/UserReducer';

function SettingsCommunicationSS() {
    const dispatch = useDispatch();
    const [smsAccess, setSmsAccess] = useState(false);
    const [emailAccess, setEmailAccess] = useState(true);
    const user = useSelector(getAuthReducer);
    const { userAccountDetails } = useSelector(getUserSelector);
    const CUID = user?.auth?.username;
    useEffect(() => {
        if (userAccountDetails) {
            setSmsAccess(userAccountDetails.SMSAccess);
        }
    }, [userAccountDetails]);

    useEffect(() => {
        dispatch({
            type: sagaActions.GET_USER_ACCOUNT_DETAILS,
            payload: {
                cu_id: CUID,
                crud_type: 'S',
                profile_picture: null,
            },
        });
    }, [CUID, dispatch]);

    const handleSmsToggle = () => {
        const newSmsAccess = !smsAccess;
        setSmsAccess(newSmsAccess);
        dispatch({
            type: sagaActions.UPDATE_ACCOUNT_SETTINGS_COMMUNICATION_DETAILS,
            payload: {
                CUID: CUID,
                SMSValue: newSmsAccess,
            },
        });
    };

    const handleEmailToggle = (e) => {
        e.preventDefault();
        setEmailAccess(prev => !prev);
    };

    return (
        <div className='acc-settings-body-for-communication px-3 '>
            <div className='d-flex flex-column align-items-start'>
                <h4>{AppConstant.login.communication}</h4>
                <div style={{ marginTop: '2rem' }}>
                    <div style={{ display:"flex", alignItems:"center", gap:"12px", fontSize:"16px"}}>
                        <span>Text(SMS) Message </span>
                        <CommonToggleSwitch
                            title=""
                            value={smsAccess}
                            onChangeValue={handleSmsToggle}
                            allowPermissionD={true}
                        />
                    </div>
                </div>
                <div onClick={handleEmailToggle} style={{ display:"flex", alignItems:"center", gap:"12px", fontSize:"16px", marginTop: '2rem'}}>
                        <span>Email Access </span>
                {/* <div onClick={handleEmailToggle} style={{ cursor: 'pointer', marginTop: '0.75rem' }}> */}
                    <CommonToggleSwitch
                        title=""
                        value={emailAccess}
                        onChangeValue={() => { }}
                        allowPermissionD={false}
                    />
                {/* </div> */}
                </div>
            </div>
        </div >
    );
}

export default SettingsCommunicationSS